import React from 'react'
import ApartmentPrice from "./ApartmentPrice";

const imageStyle = {
    width: 280,
    height: 120,
    objectFit: 'cover'
}

export default ({point, onClose}) => (
  <div className='apartment-box apartment-box--mini'>
    <div className="close-box" onClick={onClose}>x</div>
    <article id={point.id}>
      <div className='apartment-box__item apartment-photos'>
        <a target='_blank' href={point.url}>
          <img src={point.photos[1]} alt='Image' style={imageStyle} />
        </a>
      </div>
      <div className='apartment-box__item apartment-details'>
        <div className='apartment-details__row'>
          <div className='apartment-city'>
              {point.city}
          </div>
        </div>
        <div className='apartment-details__row'>
          <header className='apartment-title'>
            <a target='_blank' href={point.url}>
              <h3>{point.title}</h3>
            </a>
          </header>
        </div>
        <div className='apartment-details__row'>
          <ApartmentPrice apartment={point} />
        </div>
      </div>
    </article>
  </div>
)
